import React from 'react';
import { Link } from 'react-router-dom';

const Home: React.FC = () => {
  return (
    <div className="space-y-16">
      {/* Hero Section */}
      <section className="text-center py-16 bg-white rounded-natural shadow-natural">
        <h1 className="text-5xl font-bold mb-6 text-clay-500">
          Natural Learning Environment
          <span className="block text-sage-400 mt-2">for Your Child</span>
        </h1>
        <p className="text-xl text-earth-400 max-w-2xl mx-auto mb-8">
          I provide a nurturing Montessori environment where children can grow, learn, and discover their natural potential.
        </p>
        <Link to="/contact" className="btn-natural">
          Schedule a Visit
        </Link>
      </section>

      {/* Features Grid */}
      <section className="grid grid-cols-1 md:grid-cols-3 gap-8">
        <div className="card-natural">
          <h3 className="text-2xl font-semibold mb-4 text-clay-400">Natural Learning</h3>
          <p className="text-earth-400">
            My environment is designed to encourage exploration and discovery through natural materials and hands-on experiences.
          </p>
        </div>
        <div className="card-natural">
          <h3 className="text-2xl font-semibold mb-4 text-clay-400">Child-Led Development</h3>
          <p className="text-earth-400">
            I follow the Montessori principle of allowing children to learn at their own pace and pursue their interests.
          </p>
        </div>
        <div className="card-natural">
          <h3 className="text-2xl font-semibold mb-4 text-clay-400">Outdoor Activities</h3>
          <p className="text-earth-400">
            Regular outdoor activities and nature exploration are essential parts of my daily program.
          </p>
        </div>
      </section>

      {/* Programs Overview */}
      <section className="bg-white rounded-natural shadow-natural p-8">
        <h2 className="text-3xl font-bold text-center mb-8 text-clay-500">My Programs</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          <div className="space-y-4">
            <h3 className="text-2xl font-semibold text-sage-500">Toddler Program</h3>
            <p className="text-earth-400">Ages 18 months - 3 years</p>
            <ul className="list-disc list-inside text-earth-400 space-y-2">
              <li>Gentle introduction to social interaction</li>
              <li>Basic practical life activities</li>
              <li>Sensorial exploration</li>
            </ul>
          </div>
          <div className="space-y-4">
            <h3 className="text-2xl font-semibold text-sage-500">Preschool Program</h3>
            <p className="text-earth-400">Ages 3 - 6 years</p>
            <ul className="list-disc list-inside text-earth-400 space-y-2">
              <li>Advanced Montessori materials</li>
              <li>Language and mathematics</li>
              <li>Cultural and science activities</li>
            </ul>
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="text-center py-12 bg-sage-100 rounded-natural">
        <h2 className="text-3xl font-bold mb-4 text-clay-500">Join My Program</h2>
        <p className="text-xl text-earth-400 mb-8">
          Experience the difference of my natural learning environment.
        </p>
        <Link to="/contact" className="btn-natural">
          Enroll Now
        </Link>
      </section>
    </div>
  );
};

export default Home; 